import React from 'react';
import { Grid } from '@material-ui/core';
import { MIN_6_12_EL_WIDTH } from '../../common/common';
import HistPriceGraph from './HistPriceGraph';
import OperationsPrices from './OperationsPrices';

export const PriceAnalyticsIndex = () => {
    return (
        <Grid container spacing={3} justify="center">
            <Grid item xs={12} style={{ backgroundColor: 'clear', minWidth: MIN_6_12_EL_WIDTH }}>
                <HistPriceGraph />
            </Grid>
            <Grid item xs={6} style={{ backgroundColor: 'clear', minWidth: MIN_6_12_EL_WIDTH }}>
                <OperationsPrices />
            </Grid>
        </Grid>
    );
};
